<template>
  <button type="button" class="btn btn-primary btn-sm" @click="showModal()"><font-awesome-icon icon="plus" /> Hinzufügen</button>

  <!-- Register User Modal -->
  <div class="modal fade" id="editDruckvorlageModal" tabindex="-1" aria-labelledby="editDruckvorlageModal" aria-hidden="true" ref="editDruckvorlageModalRef">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary py-2">
          <span class="modal-title my-auto" id="editDruckvorlageModalLabel">Benutzer hinzufügen</span>

          <button type="button" class="btn-close btn-sm text-white" @click="closeModal()"></button>
        </div>

        <div class="modal-body" id="editDruckvorlageModalBody">
          <form @submit.prevent="registerUser">
            <div class="mb-3">
              <label for="username" class="form-label fw-bold">Benutzername</label>
              <input type="text" class="form-control" id="username" v-model="newUser.username" />
            </div>

            <div class="mb-3">
              <label for="password" class="form-label fw-bold">Passwort</label>
              <input type="password" class="form-control" id="password" v-model="newUser.password" />
            </div>

            <hr class="my-3" />

            <div v-if="errorMsg != ''" class="alert alert-danger mb-3">
              Es ist ein Fehler aufgetreten:<br />
              {{ errorMsg }}
            </div>

            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-secondary me-3" @click="closeModal()">Abbrechen</button>
              <button type="submit" class="btn btn-primary">Speichern</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { ref, computed } from 'vue';
  import { Modal } from 'bootstrap';

  import { AuthRequest } from '@/models/AuthModels';

  import { useCommonStore } from '@/stores/commonStore';
  import { useAuthStore } from '@/stores/authStore';
  //#endregion

  const commonStore = useCommonStore();
  const authStore = useAuthStore();

  const newUser = ref(new AuthRequest());

  const errorMsg = computed(() => commonStore.status.registerUserErrorMsg);

  function registerUser() {
    authStore.register(newUser.value).then(() => {
      if (errorMsg.value == '') {
        closeModal();
      }
    });
  }

  //#region Modal
  const editDruckvorlageModalRef = ref();

  function closeModal() {
    Modal.getInstance(editDruckvorlageModalRef.value)?.hide();
  }

  function showModal() {
    if (editDruckvorlageModalRef.value) {
      newUser.value = new AuthRequest();
      new Modal(editDruckvorlageModalRef.value).show();
    }
  }
  //#endregion
</script>
